import * as React from 'react';

import HelpRounded from '@material-ui/icons/HelpRounded';
import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
import OrderTypeToggle from '../common/OrderTypeToggle';
import StoreHours from './StoreHours';

import PropTypes from 'prop-types';

import styles from './Header.module.css';

const PickupDetails = ({
  travelDistance,
  handleShowMap,
  handleShowSchedule,
  handlePickupToggle
}) => {
  return (
    <>
      <div className={styles.serviceDetails}>
        <div className={`${styles.serviceDetail} ${styles.detailLink}`} onClick={handleShowSchedule}>
          {/* 
            Today / Tomorrow dateOffset label not implemented
          */}
          <div className={styles.detailLabel}>
            Pickup Schedule{' '} 
            <HelpRounded style={{
              cursor:'pointer', 
              verticalAlign:'text-bottom',
              fontSize: 20 
            }} /> 
          </div>
        </div>  
        <div className={`${styles.serviceDetail} ${styles.detailLink}`}>
          <div className={styles.detailLabel} onClick={() => handleShowMap(true)}>
            { travelDistance && 
              `${travelDistance} \u2022 `
            }
            Map <LocationOnRoundedIcon style={{verticalAlign:'-7px'}}/>
          </div>
        </div>
      </div>
      <div className={styles.toggleWrap}> 
        <OrderTypeToggle inBody isPickup handlePickupClick={handlePickupToggle} />
      </div>
      <div className={styles.storeHours}>
        <StoreHours />
      </div>
    </>
  )
}

PickupDetails.propTypes = {
  travelDistance: PropTypes.string,
  handleShowMap: PropTypes.func.isRequired,
  handlePickupToggle: PropTypes.func.isRequired,
  handleShowSchedule: PropTypes.func.isRequired
}

export default PickupDetails;